import React, { useEffect, useState } from 'react'
import ColumnsDevider from '../../../customControl/ColumnsDevider'
import Select, { components } from 'react-select';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../../_actions/loader.actions';
import { getAllData, postUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import { ClearLocalStorage, GetLocalStorage } from '../../../components/commonClass/Session';
import { SelectDropDownCheckboxInputOption } from '../../../components/commonClass/CommonFunctions';

const CorporateBusinessInfo = (props: any) => {
  const { tabId, selectedTabId, setIsSaved, isConfirm, setIsConfirm, setIsRedirect, CorporateId, setWarningMessages, domainWiseDisable } = props
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [dropdownList, setDropDownList] = useState<any>([])
  const [formErrors, setFormErrors] = useState<any>({})
  const [editcleardisabled, setEditClearDisabled] = useState(true)
  const [formValue, setFormValue] = useState({
    CorporateBusinessInfoId: 0,
    CorporateId: 0,
    IndustryTypeIds: [],
    EmployeeRangeId: 0,
    CompanySizeId: 0,
    CorporateTravelIds: [],
    CommunicationChannelIds: [],
    IndustryTypeOtherDetails: '',
    UserId: 0,
  })

  const getdropdowndata = async () => {
    dispatch(loaderActions.start());
    let statusoftoken = await verifytoken();
    if (statusoftoken) {
      const list = await getAllData('/midoffice/v1/getbusinessinfooption')
      if (list?.status) {
        const communicationChannelOption = list?.data?.communicationChannelOption?.map((obj: any) => ({
          label: obj?.CommunicationChannelName,
          value: obj?.CommunicationChannelId,
        })) ?? [];
        const companySizeOption = list?.data?.companySizeOption?.map((obj: any) => ({
          label: obj?.CompanySize,
          value: obj?.CompanySizeId,
        })) ?? [];
        const corporateTraveOption = list?.data?.corporateTraveOption?.map((obj: any) => ({
          label: obj?.CorporateTravelName,
          value: obj?.CorporateTravelId,
        })) ?? [];
        const employeeRangeOption = list?.data?.employeeRangeOption?.map((obj: any) => ({
          label: obj?.EmployeeRange,
          value: obj?.EmployeeRangeId,
        })) ?? [];
        const industryTypeOption = list?.data?.industryTypeOption?.map((obj: any) => ({
          label: obj?.IndustryType,
          value: obj?.IndustryTypeId,
        })) ?? [];
        setDropDownList({ communicationChannelOption, companySizeOption, corporateTraveOption, employeeRangeOption, industryTypeOption });
      }
      else {
        setDropDownList([]);
      }
    }
    else {
      ClearLocalStorage();
      dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
      dispatch(loaderActions.end());
    }
    dispatch(loaderActions.end());
  }

  const onChange = (name: any, val: any) => {
    setFormErrors({});
    setIsSaved((save: any) => ({ ...save, BusinessInfo: false }))
    setEditClearDisabled(false);
    if (name === "CommunicationChannelIds" || name === "CorporateTravelIds") {
      setFormValue((form: any) => ({ ...form, [name]: val.map((obj: any) => obj.value) }))
    }
    else if (name === 'IndustryTypeIds') {
      if (val?.includes(7)) {
        setFormValue((form: any) => ({ ...form, [name]: val.map((obj: any) => obj.value) }))
      }
      else {
        setFormValue((form: any) => ({ ...form, [name]: val.map((obj: any) => obj.value), IndustryTypeOtherDetails: '' }))
      }
    }
    else {
      setFormValue((form: any) => ({ ...form, [name]: val }))
    }
  }

  const validation = () => {
    let status: boolean = true;
    const error: any = {}
    if ((formValue?.IndustryTypeIds as (string | number)[])?.includes(7) && formValue?.IndustryTypeOtherDetails?.trim()?.length === 0) {
      error["IndustryTypeOtherDetails"] = "Cannot leave blank, please provide Other Details.";
      status = false;
    }
    setFormErrors(error);
    return status;
  }

  const saveDate = async () => {
    setIsConfirm(isConfirm === 1 && selectedTabId === tabId ? 2 : 0);
    if (validation()) {
      dispatch(loaderActions.start());
      let statusoftoken = await verifytoken();
      if (statusoftoken) {
        let user: any = GetLocalStorage();
        formValue.UserId = user?.userMasterID
        formValue.CorporateId = Number(formValue.CorporateId)
        const RpsData = await postUsersData("/midoffice/v1/insertorupdatecorporatebusinessinfo", formValue);
        if (RpsData?.status) {
          setIsSaved((save: any) => ({ ...save, BusinessInfo: true }))
          setIsRedirect(true);
          setFormErrors({})
          dispatch({ type: 'ALERTING', message: RpsData?.message })
        }
        else {
          dispatch({ type: 'ALERTING', message: RpsData?.message })
        }
        dispatch(loaderActions.end());
      }
      else {
        ClearLocalStorage();
        dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        dispatch(loaderActions.end());
      }

    }
  }

  const getbyid = async (id: any) => {
    dispatch(loaderActions.start());
    let statusoftoken = await verifytoken();
    if (statusoftoken) {
      const list = await getAllData(`/midoffice/v1/getcorporatebusinessinfobyid?corporateid=${id}`)
      if (list?.status && list?.data) {
        setFormValue({
          CorporateBusinessInfoId: list?.data?.[0]?.CorporateBusinessInfoId ? list?.data?.[0]?.CorporateBusinessInfoId : 0,
          CorporateId: Number(id),
          IndustryTypeIds: list?.data?.[0]?.IndustryTypeIds ? list?.data?.[0]?.IndustryTypeIds : [],
          EmployeeRangeId: list?.data?.[0]?.EmployeeRangeId ? list?.data?.[0]?.EmployeeRangeId : 0,
          CompanySizeId: list?.data?.[0]?.CompanySizeId ? list?.data?.[0]?.CompanySizeId : 0,
          CorporateTravelIds: list?.data?.[0]?.CorporateTravelIds ? list?.data?.[0]?.CorporateTravelIds : [],
          CommunicationChannelIds: list?.data?.[0]?.CommunicationChannelIds ? list?.data?.[0]?.CommunicationChannelIds : [],
          IndustryTypeOtherDetails: list?.data?.[0]?.IndustryTypeOtherDetails ? list?.data?.[0]?.IndustryTypeOtherDetails : '',
          UserId: 0,
        })
      }
      dispatch(loaderActions.end());
    }
    else {
      ClearLocalStorage();
      dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
      dispatch(loaderActions.end());
    }
  }

  const clearData = () => {
    setIsSaved((save: any) => ({ ...save, BusinessInfo: false }))
    setFormValue((form: any) => ({
      ...form,
      IndustryTypeIds: [],
      EmployeeRangeId: 0,
      CompanySizeId: 0,
      CorporateTravelIds: [],
      CommunicationChannelIds: [],
      IndustryTypeOtherDetails: '',
    }))
  }
  useEffect(() => {
    if (CorporateId) {
      setFormValue((form) => ({ ...form, CorporateId: Number(CorporateId) }));
      getbyid(CorporateId)
    }
  }, [CorporateId])

  useEffect(() => {
    getdropdowndata();
  }, [])

  useEffect(() => {
    if (isConfirm === 1 && selectedTabId === tabId) {
      saveDate()
    }
  }, [isConfirm])

  return (
    <div className='row mt-5'>
      <ColumnsDevider label='Industry Type'>
        <Select
          className="dropdown select_dropdown custom_class"
          options={dropdownList?.industryTypeOption}
          value={dropdownList?.industryTypeOption?.filter((industryTypeOption: any) => (formValue?.IndustryTypeIds as (string | number)[])?.includes(industryTypeOption?.value))}
          onChange={(e: any) => onChange('IndustryTypeIds', e)}
          isDisabled={location?.state?.disabled || domainWiseDisable?.isExternalUser}
          components={{ Option: SelectDropDownCheckboxInputOption }}
          isSearchable={true}
          isClearable
          hideSelectedOptions={false}
          closeMenuOnSelect={false}
          isMulti
        />
        <input type="text"
          id="IndustryTypeOtherDetails"
          className="form-control mt-1"
          name='IndustryTypeOtherDetails'
          value={formValue?.IndustryTypeOtherDetails}
          disabled={location?.state?.disabled || domainWiseDisable?.isExternalUser || ((formValue?.IndustryTypeIds as (string | number)[])?.includes(7) ? false : true)}
          onChange={(e: any) => onChange('IndustryTypeOtherDetails', e?.target?.value)}
          maxLength={100}
          placeholder='Other Details' />
        {formErrors?.IndustryTypeOtherDetails && <div className='text-danger text-start fs_14'>{formErrors?.IndustryTypeOtherDetails}</div>}
      </ColumnsDevider>

      <ColumnsDevider label='No. of Employees'>
        <Select
          className="dropdown select_dropdown custom_class"
          options={dropdownList?.employeeRangeOption}
          value={dropdownList?.employeeRangeOption?.filter((employeeRangeOption: any) => {
            return employeeRangeOption.value === formValue?.EmployeeRangeId;
          })}
          onChange={(e: any) => onChange('EmployeeRangeId', e?.value)}
          isDisabled={location?.state?.disabled || domainWiseDisable?.isExternalUser}
          isSearchable={true}
          isClearable
        />
      </ColumnsDevider>

      <ColumnsDevider label='Company Size'>
        <Select
          className="dropdown select_dropdown custom_class"
          options={dropdownList?.companySizeOption}
          value={dropdownList?.companySizeOption?.filter((companySizeOption: any) => {
            return companySizeOption.value === formValue?.CompanySizeId;
          })}
          onChange={(e: any) => onChange('CompanySizeId', e?.value)}
          isDisabled={location?.state?.disabled || domainWiseDisable?.isExternalUser}
          isSearchable={true}
          isClearable
        />
      </ColumnsDevider>

      <ColumnsDevider label='Preferred Communication Channel'>
        <Select
          className="dropdown select_dropdown custom_class"
          options={dropdownList?.communicationChannelOption}
          value={dropdownList?.communicationChannelOption?.filter((communicationChannelOption: any) => (formValue?.CommunicationChannelIds as (string | number)[])?.includes(communicationChannelOption?.value))}
          onChange={(e: any) => onChange('CommunicationChannelIds', e)}
          isDisabled={location?.state?.disabled || domainWiseDisable?.isExternalUser}
          components={{ Option: SelectDropDownCheckboxInputOption }}
          isSearchable={true}
          hideSelectedOptions={false}
          closeMenuOnSelect={false}
          isMulti
          isClearable
        />
      </ColumnsDevider>

      <div className='row m-0 p-0'>
        <ColumnsDevider label='Corporate Travel Requirement'>
          <Select
            className="dropdown select_dropdown custom_class"
            options={dropdownList?.corporateTraveOption}
            value={dropdownList?.corporateTraveOption?.filter((corporateTraveOption: any) => (formValue?.CorporateTravelIds as (string | number)[])?.includes(corporateTraveOption?.value))}
            onChange={(e: any) => onChange('CorporateTravelIds', e)}
            isDisabled={location?.state?.disabled || domainWiseDisable?.isExternalUser}
            components={{ Option: SelectDropDownCheckboxInputOption }}
            isSearchable={true}
            hideSelectedOptions={false}
            closeMenuOnSelect={false}
            isMulti
            isClearable
          />
        </ColumnsDevider>
      </div>

      <div className="mt-3 d-flex justify-content-center mt-5">
        <button type="button" className="btn btn-primary mx-1 px-3" disabled={location?.state?.disabled || editcleardisabled || domainWiseDisable?.isExternalUser} onClick={() => saveDate()} id="btnAdd">{domainWiseDisable?.loginUserDomainMasterId !== 1 ? "Save AS Draft" : (location?.state?.viewtype === 'Update' ? 'Update' : 'Save')}</button>
        <button type="button" className="btn btn-primary mx-1 px-3" disabled={editcleardisabled || location?.state?.disabled || domainWiseDisable?.isExternalUser} onClick={() => clearData()} id="btnAdd">Clear</button>
        <button type="button" className="btn btn-primary mx-1 px-3" onClick={() => navigate('/corporate-management')} id="btnClear">Back</button>
      </div>
    </div>
  )
}


export default CorporateBusinessInfo